import { useQuery } from '@tanstack/react-query';
import api from '~/api';

/** Claim history across every store; the API only answers for Corso CX agents. */
export function useConciergeCustomer(customerEmail?: string) {
  const queryKey = ['conciergeCustomer', `${customerEmail}`];
  return useQuery({
    queryKey,
    queryFn: () => {
      if (!customerEmail) throw new Error('Customer email is required');
      return api.conciergeCustomer({ customerEmail });
    },
    enabled: !!customerEmail,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
